module.exports = __webpack_public_path__ + "img/image-tanya-removebg-preview.4558e7bd.png";